import { useMemo } from 'react'
import CssBaseline from '@mui/material/CssBaseline'
import { createTheme, ThemeProvider as MUIThemeProvider } from '@mui/material/styles'

import overrides from './overrides'
import { palette } from './palette'
import { typography } from './typography'

const shadcnShadows = [
  'none',
  '0 1px 2px 0 rgb(0 0 0 / 0.05)',
  '0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)',
  '0 2px 8px 0 rgb(0 0 0 / 0.08)',
  ...Array(21).fill('0 2px 8px 0 rgb(0 0 0 / 0.08)'),
]

export default function ThemeProvider({ children, mode = 'light' }) {
  const memoizedValue = useMemo(
    () => ({
      palette: palette(mode),
      typography,
      shadows: shadcnShadows,
      shape: { borderRadius: 4 },
    }),
    [mode],
  )

  const theme = createTheme(memoizedValue)
  theme.components = overrides(theme)

  return (
    <MUIThemeProvider theme={theme}>
      <CssBaseline enableColorScheme />
      {children}
    </MUIThemeProvider>
  )
}
